import { Provider } from '@angular/core';
import {
  Chart,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  LineController,
  BarController,
  PieController,
  DoughnutController,
} from 'chart.js';

// Register all Chart.js components
Chart.register(
  // Scales
  CategoryScale,
  LinearScale,
  // Elements
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  // Controllers
  LineController,
  BarController,
  PieController,
  DoughnutController,
  // Plugins
  Title,
  Tooltip,
  Legend,
  Filler
);

export function provideChartJs(): Provider[] {
  return [];
}
